@if (naytaKenttana()) {
  <mat-form-field>
    <mat-label>{{ otsikko() }}</mat-label>
    <input #hakukentta type="text" matInput autocomplete="off" [formField]="hakusana" [matAutocomplete]="hakulista" [placeholder]="'lasku.yksikko-haku' | translate | async" (focus)="valitseHakukentanTeksti()" (blur)="kasitteleFokuksenMenetys()" />
  </mat-form-field>
} @else {
  <input #hakukentta class="rivin-hakukentta" type="text" autocomplete="off" [formField]="hakusana" [matAutocomplete]="hakulista" [placeholder]="'lasku.yksikko-haku' | translate | async" [attr.aria-label]="'lasku.yksikko-haku' | translate | async" (blur)="kasitteleFokuksenMenetys()" (keydown.escape)="peruutaHaku()" />
}

<mat-autocomplete #hakulista="matAutocomplete" [autoActiveFirstOption]="!naytaKenttana()" panelWidth="300px" (optionSelected)="valitseYksikko($event.option.value)" (closed)="vahvistaHaku()">
  @if (yksikkoehdotuksetObservable | async; as ehdotukset) {
    @if (ehdotukset.naytetaankoYleisimmat) {
      <div class="yksikkolistan-otsikko">{{ 'lasku.yksikko-yleisimmat' | translate | async }}</div>
    }
    @for (yksikko of ehdotukset.yksikot; track yksikko.tunnus) {
      <mat-option [value]="yksikko.tunnus">
        <span class="yksikon-tiedot">
          <b>{{ yksikko.tunnus }}</b>
          <span class="yksikon-nimi">{{ yksikko.nimi }}</span>
          <span class="yksikon-koodi">{{ yksikko.unKoodi }}</span>
        </span>
      </mat-option>
    } @empty {
      <div class="yksikkolistan-otsikko">{{ 'lasku.yksikko-ei-osumia' | translate | async }}</div>
    }
  }
</mat-autocomplete>
